import { signIn, type SessionState } from "./session";

/** Shown when there's no session (or auth isn't set up on this deploy). */
export function SignInScreen({ state }: { state: Exclude<SessionState, { kind: "signed-in" }> }) {
  return (
    <div className="page">
      <header className="site-header">
        <div className="site-header-text">
          <h1>Storefront</h1>
          <p className="tagline">A small shop, five languages under the hood.</p>
        </div>
      </header>

      <main>
        <section className="signin">
          {state.kind === "signed-out" && (
            <>
              <h2>Sign in to shop</h2>
              <p>
                This demo uses Auth0 for accounts. Use the seeded{" "}
                <code>demo-customer@example.com</code> (or your own account).
              </p>
              <button type="button" className="signin-button" onClick={() => signIn("/")}>
                Sign in
              </button>
            </>
          )}

          {state.kind === "no-auth" && (
            <>
              <h2>Auth isn't set up here yet</h2>
              <p>
                This deployment's BFF has no Auth0 tenant configured. See{" "}
                <code>docs/auth0-setup.md</code>, then set the <code>AUTH0_*</code>{" "}
                GitHub Actions values and redeploy.
              </p>
            </>
          )}

          {state.kind === "unreachable" && (
            <>
              <h2>Can't reach the backend</h2>
              <p>
                The storefront talks to its BFF at <code>/api</code> / <code>/auth</code>.
                Locally, run <code>web-bff</code> (<code>dotnet run</code>) — the Vite dev
                server proxies to it.
              </p>
            </>
          )}
        </section>
      </main>
    </div>
  );
}
